'use strict';

var ACTION_TYPES = require('./actionTypes');

module.exports = {

  /**
   * Change ShapeJs params based on selected params
   * @param shapeJsId
   * @param paramValues
   * @returns {{type: string, payload: {shapeJsId: string, paramValues: object}}}
   */
  shapeJsViewerUpdateParams: function shapeJsViewerUpdateParams(shapeJsId, paramValues) {
    return {
      type: ACTION_TYPES.SHAPE_JS_UPDATE_PARAMS,
      payload: {
        shapeJsId: shapeJsId,
        paramValues: paramValues
      }
    };
  },

  /**
   * Change ShapeJs params when selecting different material
   * @param shapeJsId
   * @param materialAbbreviation
   * @param isFullColorMaterial
   * @param currentModelJson
   * @returns {{type: string, payload: {shapeJsId: string, materialAbbreviation: string, isFullColorMaterial: boolean, currentModelJson: *}}}
   */
  selectMaterialShapeJs: function selectMaterialShapeJs(shapeJsId, materialAbbreviation, isFullColorMaterial, currentModelJson) {
    return {
      type: ACTION_TYPES.SHAPE_JS_MATERIAL_SELECTED,
      payload: {
        shapeJsId: shapeJsId,
        materialAbbreviation: materialAbbreviation,
        isFullColorMaterial: isFullColorMaterial,
        currentModelJson: currentModelJson
      }
    };
  }
};
